
import { Component } from "@angular/core";

@Component({
    selector: "app-ticket-info-card",
    imports: [],
    templateUrl: "./ticket-info-card.component.html",
    styleUrl: "./ticket-info-card.component.scss"
})
export class TicketInfoCardComponent {}
